import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';

// Fonte única para saber se a marcação de autopreenchimento deve usar a variante Fidelize
// (texto neutro, sem atribuir à IA).
function useIsFidelizeAutofill(): boolean {
  const { origin_channel } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );

  return origin_channel === 'fidelize';
}

export default useIsFidelizeAutofill;
